import { type IDataTransformer } from '../interfaces';
import { GenericDataTransformer } from './generic-data-transformer';

export class PieDataTransformer
  extends GenericDataTransformer
  implements IDataTransformer<google.visualization.DataTable> {}
